module.exports = __webpack_public_path__ + "static/media/logowhite.66228d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-img/logowhite.png
// module id = 1427
// module chunks = 0